<template>
  <div>



 <el-table :data="DataList" stripe style="width: 100%" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center',background:'#F5F7FA'}"
      :row-style="{background:'#ffffff'}">

      <el-table-column prop="itemNum" label="项目编号">
      </el-table-column>
      <el-table-column prop="itemName" label="项目名称">
      </el-table-column>
      <el-table-column prop="price" label="挂牌价格">
      </el-table-column>
   <el-table-column label="挂牌价格类型" width="200px">
     <template slot-scope="scope">
       {{getEnumByCode(scope.row.priceType)}}

     </template>
     </el-table-column>
      <el-table-column prop="publishTime" label="发布日期">
      </el-table-column>
    <el-table-column prop="transactionPrice" label="最后成交价">
    </el-table-column>
    <el-table-column prop="contractStartDate" label="合同开始时间">
    </el-table-column>
    <el-table-column prop="contractEndDate" label="合同结束时间">
    </el-table-column>


     <el-table-column fixed="right" label="操作" width="150px">
          <template slot-scope="scope">

            <a target="_blank" :href="scope.row.contractFile" v-if="scope.row.contractFile!=null&&scope.row.contractFile!=''" >
            <el-button type="primary" size="small" plain>查询合同附件
            </el-button>
              </a>

          </template>
        </el-table-column>


      </el-table>

   <!--   <div style="width:24%;height:250px;" v-for="(item,index) in DataList">
        <div style="width:50%;height:240px;">{{item}}
          <img src="">
        </div>

      </div>
 -->
      <div class="tabListPage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>




  </div>

</template>

<script>
  export default {
    data() {
      return {
        unitCode: "410621000000",//焦作 410800000000
        pageNum: 1, // 默认显示第几页
        totalCount: 1, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 10, // 默认每页显示的条数（可修改）
        DataList: [],
        countys:[],
        towns:[],
        villages:[],
        countyCode:"",
        townCode:"",
        villageCode:"",
        type:"",
        emnus:[],


      }
    },
    created() {
      this.getData()
    this.getEmnusByType(2);
      },
      methods: {
        async getEmnusByType(type){
          const action = "/web/queryEnumsByType/"+type;
          const {
            data: res
          } = await this.$http.get(action);
          this.emnus=res.data;
        },
         getEnumByCode(code){
          return this.emnus.find(d => d.code === code).desc;
        },

      jump(row) {
        window.sessionStorage.setItem("projectId",row.id);
        if(row.tradeWay==1){
           this.$router.push("/forwardBidding");
           }
          if(row.tradeWay==2){
             this.$router.push("/ladderBidding");
             }
      },
      async getData(unitCode) {
        var num = this.pageNum;
        // if (this.pageNum != 0) {
        //   num = this.pageNum - 1;
        // }
        const {
          data: res
        } = await this.$http.get('/web/v1/win/list?pageNum=' + num + "&pageSize=" + this
          .pageSize );
        this.DataList = res.data.list;
        this.totalCount = res.data.total;
        console.log(res);
      },
      showModal(id){
        alert(id)
      },

      // 每页显示的条数，选择每页条数的时候执行
      handleSizeChange(val) {
        this.pageSize = val // 改变每页显示的条数
        this.searchData(this.searchUnitCode);
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      // 显示第几页
      handleCurrentChange(val) {
        console.log("handleCurrentChange")
        this.pageNum = val; // 改变默认的页数
        this.searchData(this.searchUnitCode);
      },

    },


  }
</script>

<style lang="scss" scoped="">
  .select {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .lable {
    width: 83px;
    color: black;
    font-size: 15px;
    float: left;
    line-height: 40px;
    text-align: right;
  }

  .inp {
    width: 48%;
    height: 32px;
    border: 1px solid #ccc;

  }



  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
